import { Helmet } from "react-helmet-async";
import DemoSection from "@/components/DemoSection";

const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Who is Best Virtual Tutor for?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Anyone. Students, exam candidates, professionals and lifelong learners can set a level from beginner to advanced and learn any subject at their own pace."
      }
    },
    {
      "@type": "Question",
      "name": "What subjects can I learn?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Maths, science, coding, languages, writing, business and test preparation, plus general questions across almost any topic."
      }
    },
    {
      "@type": "Question",
      "name": "Can I try it before paying?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. You get five free messages without an account, and a free trial plan with more sessions once you sign up."
      }
    },
    {
      "@type": "Question",
      "name": "How do I cancel my subscription?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Cancel anytime from Manage subscription inside your workspace — no questions asked, no hidden fees."
      }
    }
  ]
};

const organizationStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Best Virtual Tutor",
  "url": "https://bestvirtualtutor.com/",
  "description": "A patient AI tutor for learners of any age and any subject."
};

const webAppStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": "Best Virtual Tutor",
  "applicationCategory": "EducationalApplication",
  "operatingSystem": "Web",
  "url": "https://bestvirtualtutor.com/",
  "description": "An AI tutor workspace for any subject and any level, with voice conversation and step-by-step explanations.",
  "offers": [
    { "@type": "Offer", "name": "Free Trial", "price": "0", "priceCurrency": "USD" },
    { "@type": "Offer", "name": "Monthly", "price": "14.99", "priceCurrency": "USD" },
    { "@type": "Offer", "name": "Annual", "price": "99", "priceCurrency": "USD" }
  ]
};

const Index = () => (
  <>
    <Helmet>
      <title>Best Virtual Tutor | AI Tutor for Any Subject, Any Level</title>
      <meta
        name="description"
        content="A patient AI tutor for learners of every age. Ask anything, pick your level, and get clear step-by-step explanations in maths, science, coding, languages and more."
      />
      <link rel="canonical" href="https://bestvirtualtutor.com/" />
      <meta property="og:title" content="Best Virtual Tutor | AI Tutor for Any Subject, Any Level" />
      <meta
        property="og:description"
        content="A patient AI tutor for learners of every age. Ask anything, pick your level, and learn at your own pace."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://bestvirtualtutor.com/" />
      <script type="application/ld+json">{JSON.stringify(faqStructuredData)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationStructuredData)}</script>
      <script type="application/ld+json">{JSON.stringify(webAppStructuredData)}</script>
    </Helmet>
    <main className="min-h-[100dvh]">
      <DemoSection />
    </main>
  </>
);

export default Index;
